export default "__VITE_ASSET__D0SIe5Dk__"